import { render, staticRenderFns } from "./priceChangeModal.vue?vue&type=template&id=28364746"
import script from "./priceChangeModal.vue?vue&type=script&lang=js"
export * from "./priceChangeModal.vue?vue&type=script&lang=js"
import style0 from "./priceChangeModal.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports